import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Ask({ symbol_id }) {
  const socket = useContext(SocketContext);
  const [ask, setAsk] = useState(0);

  useEffect(() => {
    // Emit initial request
    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data !== null && typeof data.Ask !== "undefined") {
        setAsk(data.Ask);
      }
    };

    // Subscribe to symbol updates
    socket.on(`trade${symbol_id}`, tradeListener);

    // Clean up on unmount or symbol_id change
    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]); // Re-run effect when symbol_id changes

  return (
    <div className="menuSellPrice addFlex">
      <CheckValue number={ask} extra={"AddFontSize"} />
    </div>
  );
}
